export default "__VITE_ASSET__CNy6mXPZ__"